import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { createRoot } from 'react-dom/client';

import { App } from './App';

class WebComponent extends HTMLElement {
    connectedCallback() {
        this.root = createRoot(this);

        this.root.render(
           <Router>
            <App 
                minuteInterval={Number(this.getAttribute('minuteInterval')) || 30}
                minHour={Number(this.getAttribute('minHour')) || 0}
                maxHour={Number(this.getAttribute('maxHour')) || 23}
                layout={this.getAttribute('layout') || "parking-single-line"}
                airportCode={this.getAttribute('airportCode')}
            />
           </Router>
        , this);
    }

    disconnectedCallback() {
        this.root.unmount();
        delete this.root;
    }
}

const ELEMENT_ID = 'aena-parkings-bus-custom-element';

if (!customElements.get(ELEMENT_ID)) {
    customElements.define(ELEMENT_ID, WebComponent);
}